import {Injectable} from "@angular/core";
import {BaseApi} from "./baseService";
import {BaseResponse} from "../objects/common/baseResponse";
import {RequestOptions, URLSearchParams} from "@angular/http";
import {OrderContent} from "../objects/orders/orderContent";
/**
 * Created by alex.y on 10/3/2017.
 */


@Injectable()
export class OrderContentService extends BaseApi {
    protected controllerUrl = 'ordercontent';

    public getByOrderIdAndStatus(orderId: number, orderStatus: number = null): Promise<BaseResponse<Array<OrderContent>>> {
        let params = new URLSearchParams();

        if(orderStatus)
            params.append('orderstatus', orderStatus.toString());

        return this.get(new RequestOptions({
            url: `${this.controllerUrl}/${orderId}`,
            search: params
        }));
    }

    public modify(contents: Array<OrderContent>): Promise<BaseResponse<Array<OrderContent>>> {
        return this.post(new RequestOptions({
            url: `${this.controllerUrl}`,
            body: contents
        }))
    }

    public deleteByIds(ids: number[]): Promise<BaseResponse<void>> {
        let params = new URLSearchParams();

        ids.forEach(i => params.append("ids", i.toString()));

        return this.delete(new RequestOptions({
            url: `${this.controllerUrl}`,
            search: params
        }))
    }
}


// WEBPACK FOOTER //
// ./app/services/orderContentService.ts